AFRAME.registerComponent('app-state-display', {
    schema: {
        position: { type: 'vec3', default: { x: 0, y: 0, z: 0.01 } }, // Position of the container entity
        color: { type: 'string', default: '#FFFFFF' },                  // Text color
        fontSize: { type: 'number', default: 0.2 }                     // Font size
    },

    init: function () {
        // Create a container entity
        this.containerEntity = document.createElement('a-entity');
        this.el.appendChild(this.containerEntity);

        // Create a text entity inside the container
        this.textEntity = document.createElement('a-text');
        this.containerEntity.appendChild(this.textEntity);

        // Set attributes for the container entity
        this.containerEntity.setAttribute('position', this.data.position);

        // Set attributes for the text entity
        this.textEntity.setAttribute('position', '0 0 0'); // Relative to container
        this.textEntity.setAttribute('color', this.data.color);
        this.textEntity.setAttribute('scale', `${this.data.fontSize} ${this.data.fontSize} ${this.data.fontSize}`);
        this.textEntity.setAttribute('align', 'left');
        this.textEntity.setAttribute('width', '2'); // Width to prevent wrapping

        // Store previous AppState values for comparison
        this.previousState = {
            isTrueVRMode: window.AppState.isTrueVRMode,
            isPseudoVRMode: window.AppState.isPseudoVRMode,
            isDesktopMode: window.AppState.isDesktopMode,
            isFullscreen: window.AppState.isFullscreen,
            isMobileDevice: window.AppState.isMobileDevice
        };

        // Initial update
        this.updateDisplay();

        // Bind tick for change detection
        this.tick = this.tick.bind(this);
    },

    updateDisplay: function () {
        // Construct the display string from AppState variables
        const stateText = `
            True VR: ${window.AppState.isTrueVRMode}
            Pseudo VR: ${window.AppState.isPseudoVRMode}
            Desktop: ${window.AppState.isDesktopMode}
            Fullscreen: ${window.AppState.isFullscreen}
            Mobile: ${window.AppState.isMobileDevice}
        `.trim();

        this.textEntity.setAttribute('value', stateText);
    },

    hasStateChanged: function () {
        // Compare current AppState with previous state
        return (
            window.AppState.isTrueVRMode !== this.previousState.isTrueVRMode ||
            window.AppState.isPseudoVRMode !== this.previousState.isPseudoVRMode ||
            window.AppState.isDesktopMode !== this.previousState.isDesktopMode ||
            window.AppState.isFullscreen !== this.previousState.isFullscreen ||
            window.AppState.isMobileDevice !== this.previousState.isMobileDevice
        );
    },

    tick: function () {
        // Only update display if AppState has changed
        if (this.hasStateChanged()) {
            this.updateDisplay();

            // Update previous state to current values
            this.previousState.isTrueVRMode = window.AppState.isTrueVRMode;
            this.previousState.isPseudoVRMode = window.AppState.isPseudoVRMode;
            this.previousState.isDesktopMode = window.AppState.isDesktopMode;
            this.previousState.isFullscreen = window.AppState.isFullscreen;
            this.previousState.isMobileDevice = window.AppState.isMobileDevice;
        }
    },

    remove: function () {
        // Clean up the container and text entities when the component is removed
        if (this.containerEntity) {
            this.el.removeChild(this.containerEntity);
        }
    }
});